/**
 * nike custom component-Error Boundary
 * @exports ErrorBoundary
 * @author {Cognizant Technology Solutions}
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import imagesPath from '../../constants/imagesPath';
import './styles.scss';
import DefaultText from '../../constants/defaultText';

interface Props {
  children: Object;
}

interface State {
  error: any;
  errorInfo: any;
}

class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error: any, errorInfo: any) {
    /** Catch errors in any components below and re-render with error message */
    this.setState({
      error,
      errorInfo
    });
    /** You can also log error messages to an error reporting service here */
  }

  render() {
    const { state } = this;
    const { children } = this.props;

    if (state.errorInfo) {
      console.log('Error: ', state.error);
      /** Error path */
      return (
        <div className="errorBoundary">
          <img src={imagesPath.imgErrorPage.src} alt={imagesPath.imgErrorPage.alt} />
          <div className="error">{DefaultText.error_txt}</div>
          <div>{DefaultText.error_reason}</div>
        </div>
      );
    }
    /** Normally, just render children */
    return children;
  }
}
ErrorBoundary.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

export default ErrorBoundary;
